import { PlanType } from '@showbie-socrative/socrative-utils';
import { QueryClient } from '@tanstack/react-query';

import { QUIZ_LIMIT_QUERY_KEY } from '~teacher/hook';
import { proCheck } from '~teacher/util/proCheck';

import { QuizLimit } from '../../../../api/quiz';
import { updateQuizCount } from './updateQuizCount';

export function decreaseQuizCount(queryClient: QueryClient, count = 1) {
  const currentQuizLimit =
    queryClient.getQueryData<QuizLimit>(QUIZ_LIMIT_QUERY_KEY);

  if (!currentQuizLimit) return; // no data to update, we do not care.

  const userPlan = proCheck.userPlan();
  if (
    [
      PlanType.FreeLegacy,
      PlanType.Pro,
      PlanType.Organization,
      PlanType.Complete,
    ].includes(userPlan)
  ) {
    return; // pro, or legacy free, we do not care.
  }

  if (count <= 0) {
    return; // Cannot decrement 0 or negative numbers.
  }

  const newQuizCount = Math.max(currentQuizLimit?.currentQuizCount - count, 0);

  updateQuizCount(queryClient, newQuizCount);
}
